import { render, staticRenderFns } from "./BasicTaxDetailsForm.vue?vue&type=template&id=604c3110&"
import script from "./BasicTaxDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./BasicTaxDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports